<template>
    <div class="report-filter-tool" :class="{ 'report-filter-tool--datetime-open': datetimeOpen }">
        <div class="date-filter">
            <SupsisButton @click="prevDate" ghost small><i class="material-icons">chevron_left</i></SupsisButton>
            <datetime
                :value="filters.startDate"
                @input="changeStartDate"
                :placeholder="$t('message.startDate')"
                auto
                input-class="form-control rounded-0"
                type="datetime"
            />
            <datetime
                v-model="filters.endDate"
                :max-datetime="getMax()"
                :min-datetime="getMaxMinDate()"
                :placeholder="$t('message.endDate')"
                auto
                input-class="form-control rounded-0"
                type="datetime"
            />
            <SupsisButton @click="nextDate" ghost small><i class="material-icons">chevron_right</i></SupsisButton>
        </div>

        <div class="input-groups">
            <div class="input-group">
                <md-chip v-if="filters.users.length === 0" class="md-primary">
                    {{ $t("message.allRepresentatives") }}
                </md-chip>
                <md-chip
                    v-for="user in getSelectedUsers()"
                    :key="user._id"
                    class="md-primary"
                    md-deletable
                    @md-delete="removeUser(user._id)"
                >
                    {{ capitalize(user.name) }}
                </md-chip>
                <md-chip
                    v-if="!autoCompleteShow && users.filter((x) => !filters.users.includes(x._id)).length"
                    class="md-accent"
                    md-clickable
                    @click="openAutoComplete"
                >
                    + {{ $t("message.addRepresentative") }}
                </md-chip>
                <md-autocomplete
                    v-if="autoCompleteShow"
                    v-model="autoCompleteValue"
                    :md-fuzzy-search="true"
                    :md-open-on-focus="true"
                    :md-options="users.filter((x) => !filters.users.includes(x._id))"
                    autofocus
                    class="ml-3"
                    md-input-id="acUsers"
                    style="margin-top: 15px"
                    @md-selected="autoCompleteSelected"
                >
                    <label>{{ $t("message.selectRep") }}</label>

                    <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                        <div style="display: flex; align-items: center; font-size: 16px">
                            <Avatar :size="40" :username="item.name" class="mr-2" style="color: white" />
                            <md-highlight-text :md-term="term">
                                {{ capitalize(item.name) }}
                            </md-highlight-text>
                        </div>
                    </template>

                    <template slot="md-autocomplete-empty" slot-scope="{ term }">
                        {{ $t("message.noRePresentativeFound") }}
                    </template>
                </md-autocomplete>
            </div>
            <div class="input-group">
                <md-chip
                    v-for="channel in getSelectedChannels()"
                    :key="channel._id"
                    class="md-primary"
                    md-deletable
                    @md-delete="removeChannel(channel._id)"
                >
                    {{ channel.name }}
                </md-chip>
                <md-chip v-if="filters.channels.length === 0" class="md-primary">
                    {{ $t("report.allChannels") }}
                </md-chip>
                <md-chip
                    class="md-accent"
                    style="background: #3f8646 !important"
                    md-clickable
                    @click="openAutoCompleteChannel"
                >
                    {{ $t("whatsappChannel.addChannel") }}
                </md-chip>
                <md-autocomplete
                    v-if="autoCompleteShowChannel"
                    v-model="channelName"
                    :md-fuzzy-search="true"
                    :md-open-on-focus="true"
                    :md-options="channels.filter((x) => !filters.channels.includes(x._id))"
                    class="ml-3"
                    md-input-id="acChannels"
                    @md-selected="autoCompleteSelectedChannel"
                >
                    <label>{{ $t("report.selectaChannel") }}</label>

                    <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                        <div style="display: flex; align-items: center; font-size: 16px">
                            <md-highlight-text :md-term="term">
                                {{ item.name }}
                            </md-highlight-text>
                        </div>
                    </template>

                    <template slot="md-autocomplete-empty" slot-scope="{ term }"> Kanal Bulunamadı</template>
                </md-autocomplete>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import moment from "moment/moment";
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../Pages/Settings/components/SupsisButton.vue";
import Avatar from "vue-avatar";

export default Vue.extend({
    name: "ReportFilterTool",
    components: { SupsisButton, Avatar },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filters: _.cloneDeep(this.value),
            maxDate: moment().toISOString(),
            autoCompleteShow: false,
            autoCompleteShowChannel: false,
            channelName: "",
            autoCompleteValue: "",
            datetimeOpen: false,
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
            isDarkMode: (state) => state.user.darkMode,
            channels: (state) => [{ _id: "web", name: "Web" }, ...state.channel.channels],
            users: (state) => state.user.users.data,
        }),
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            listChannels: "channel/listChannels",
        }),
        changeStartDate(date) {
            const diffDays = moment(this.filters.endDate).diff(moment(date), "days");
            const isMax = diffDays > 45;
            this.filters.startDate = date;
            if (isMax) this.filters.endDate = moment(date).endOf("day").toISOString();
        },
        nextDate() {
            const diffDays = moment(this.filters.endDate).diff(moment(this.filters.startDate), "days");

            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.filters.startDate = moment(this.filters.startDate).add(1, period).toISOString();
            this.filters.endDate = moment(this.filters.endDate).add(1, period).toISOString();
        },
        prevDate() {
            const diffDays = moment(this.filters.endDate).diff(moment(this.filters.startDate), "days");

            let period = diffDays < 6 ? "days" : diffDays < 28 ? "weeks" : diffDays < 360 ? "months" : "years";

            this.filters.startDate = moment(this.filters.startDate).subtract(1, period).toISOString();
            this.filters.endDate = moment(this.filters.endDate).subtract(1, period).toISOString();
        },
        getMinMinDate() {
            return this.filters.endDate ? moment(this.filters.endDate).subtract(45, "day").toISOString() : null;
        },
        getMaxMinDate() {
            return this.filters.startDate ? moment(this.filters.startDate).toISOString() : null;
        },
        getMax() {
            const afterDay = moment(this.filters.startDate).add(45, "day");

            return this.filters.startDate
                ? afterDay > moment()
                    ? moment().toISOString()
                    : moment(this.filters.startDate).add(45, "day").toISOString()
                : null;
        },
        getSelectedUsers() {
            return this.users
                ? this.filters.users.map((id) => this.users.find((x) => x._id === id)).filter((x) => x != null)
                : [];
        },
        getSelectedChannels() {
            return this.channels.length > 0
                ? this.filters.channels.map((id) => this.channels.find((x) => x._id === id)).filter((x) => x != null)
                : [];
        },
        removeUser(id) {
            this.filters.users = this.filters.users.filter((x) => x !== id);
        },
        removeChannel(id) {
            this.filters.channels = this.filters.channels.filter((x) => x !== id);
        },
        capitalize(text = "") {
            return _.startCase(text.toLowerCase().trim());
        },
        openAutoComplete() {
            this.autoCompleteShow = true;
            setTimeout(() => {
                const elem = document.getElementById("acUsers");
                if (elem) elem.click();
            }, 200);
        },
        openAutoCompleteChannel() {
            this.autoCompleteShowChannel = true;
            setTimeout(() => {
                const elem = document.getElementById("acChannels");
                if (elem) elem.click();
            }, 200);
        },
        autoCompleteSelected(user) {
            this.filters.users.push(user._id);
            this.autoCompleteShow = false;
            this.autoCompleteValue = "";
        },
        autoCompleteSelectedChannel(channel) {
            this.filters.channels.push(channel._id);
            this.autoCompleteShowChannel = false;
            this.channelName = "";
        },
        syncDatetimeLayer(open) {
            this.datetimeOpen = open;
            if (this._contentViewEl) {
                this._contentViewEl.style.zIndex = open ? "10050" : "";
            }
        },
    },
    mounted() {
        this._contentViewEl = this.$el.closest ? this.$el.closest(".content-view") : null;
        var self = this;
        this._dtObserver = new MutationObserver(function () {
            var hasPopup = !!self.$el.querySelector(".vdatetime-popup");
            if (hasPopup !== self.datetimeOpen) {
                self.syncDatetimeLayer(hasPopup);
            }
        });
        var vdatetimeEls = self.$el.querySelectorAll(".vdatetime");
        for (var i = 0; i < vdatetimeEls.length; i++) {
            self._dtObserver.observe(vdatetimeEls[i], { childList: true, subtree: true });
        }
        this.getUsers({ perPage: 1000, page: 1 });
        this.listChannels();
    },
    beforeDestroy() {
        if (this._dtObserver) this._dtObserver.disconnect();
        this.syncDatetimeLayer(false);
    },
    watch: {
        value: {
            handler: function(value) {
                const isEqual = _.isEqual(this.filters, value);
                if (!isEqual) this.filters = _.cloneDeep(value);
            },
            deep: true,
        },
        filters: {
            handler: function(value) {
                this.$emit("input", value);
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.report-filter-tool {
    display: flex;
    gap: 16px;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
    padding: 10px 14px;
    align-items: center;

    &.report-filter-tool--datetime-open {
        z-index: 10060 !important;
    }

    .date-filter {
        display: flex;
        gap: 6px;
        align-items: center;
        flex-shrink: 0;

        .vdatetime {
            width: 220px;
        }
    }

    .input-groups {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        width: 100%;
        align-items: center;

        .input-group {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            width: auto;
            align-items: center;

            .md-field {
                width: 250px;
                padding: 0;
                margin: 0;
            }
        }
    }
}
</style>
<style scoped lang="scss">
.dark-mode {
    .report-filter-tool {
        background: #1e1e2d;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }
}
</style>